import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext.jsx';
import UsersTable from '../components/users/UsersTable.jsx';
import posthog from 'posthog-js';

export default function Users() {
  const navigate = useNavigate();
  const { organization, profile, user, loading, currentOrganization } = useAuthContext();
  const perm = organization?.permissions?.user_management;
  const canAccess = perm === 'view' || perm === 'edit';
  const canEdit = perm === 'edit';

  useEffect(() => {
    posthog.capture('$pageview');
  }, []);

  useEffect(() => {
    if (!loading && organization && !canAccess) {
      navigate('/home', { replace: true });
    }
  }, [loading, organization, canAccess, navigate]);

  if (loading || !organization) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <p className="text-sm text-gray-600">Loading…</p>
        </div>
      </div>
    );
  }

  if (!canAccess) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <h1 className="text-3xl font-bold text-gray-900">Users</h1>
          <p className="mt-2 text-sm text-gray-700">
            {canEdit ? 'Invite and update' : 'View'} members of{' '}
            <span className="font-medium text-gray-900">{organization.name}</span>. Email addresses
            cannot be changed after a user exists; new addresses must use an allowed domain for this
            organization.
          </p>

          <div className="mt-6 rounded-lg bg-white p-6 shadow">
            <UsersTable
              organizationId={currentOrganization}
              organization={organization}
              profile={profile}
              sessionUserEmail={user?.email}
              canEdit={canEdit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
